"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanTypes = exports.CalculatedLoanStatuses = exports.LoanStatuses = void 0;
// ***********************************************
//                     LOAN
// ***********************************************
exports.LoanStatuses = [
    'pending',
    'canceled',
    'initiated',
    'funded',
];
exports.CalculatedLoanStatuses = ['overdue', ...exports.LoanStatuses];
exports.LoanTypes = ['origination', 'extension', 'rollover'];
//# sourceMappingURL=Loans.js.map